import {
  CursorAvailability,
  LectureStudentAnalytics,
  LectureStudentData,
} from "../domains/LectureStudentAnalytics";

export const fromJson = (
  json: Record<string, any>,
): LectureStudentAnalytics => {
  return {
    columns: json.columns.map((obj: Record<string, string>) => {
      // 列=講義。講義のない列はnullを返す
      if (!obj) {
        return null;
      }

      return {
        lectureSessionId: obj.lectureSessionId,
        allday: obj.allday,
        startAt: new Date(obj.startAt),
        endAt: new Date(obj.endAt),
      };
    }),
    students: json.students as ReadonlyArray<LectureStudentData>,
    cursor: json.cursor as CursorAvailability,
  };
};
